export interface ISnRendererStop {
  value: any;
  icon?: string;
  color?: string;
  fontSet?: string;
}

export interface ISnRender {
  icon?: string;
  imageUrl?: string;
  fontSet?: string;
  color?: string;
  rowColor?: string;
}

export interface ISnRendererCondition {
  type: string;
  field: string;
  value: string | boolean;
}

export interface ISnRendererRule {
  render: ISnRender;
  conditions: ISnRendererCondition[];
}

export interface ISnLayerRenderer {
  field: string;
  stops: ISnRendererStop[];
  rules?: ISnRendererRule[];
}

export interface ISnLayerLink {
  id: string;
  fieldTo: string;
  fieldFrom: string;
}
